import { render, staticRenderFns } from "./CuentaCrud.vue?vue&type=template&id=964afda0"
import script from "./CuentaCrud.vue?vue&type=script&lang=js"
export * from "./CuentaCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports